<template>
    <div>
        <vs-popup title="" 
            :button-close-hidden="true" 
            :active.sync="isActive" 
            @close="closePopUp"
            style="border-radius: 10px !important;"
            id="popUpQuantityChat"
            class="sizePopup"
        >
            <div>
                <span id="display-span-orders">
                    <vs-icon 
                    @click="$emit('backToProducts')" 
                    class="mr-2" 
                    icon="keyboard_arrow_left" 
                    style="border: solid 1px; border-radius: 14px; cursor: pointer;"
                    />
                    <p class="ml-2" style="font-size: 16px; width: 400px;">
                        Selecione a Quantidade
                    </p>
                    <div class="flex-end-align">
                        <vs-icon @click="closePopUp" class="mr-2" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right;"></vs-icon>
                    </div>
                </span>
            </div>

            <div>
                <vs-table
                    ref="table" 
                    :data="dataOfProductsToPreOrder.product === undefined ? dataOfProductsToPreOrder : dataOfProductsToPreOrder.product"
                    noDataText="Sem dados disponíveis"
                    id="tableDataOfQuantityChat"
                    style="padding: 0 !important;"
                >
                    <template slot="thead">
                        <vs-th class="text-base" sort-key="image">
                            Imagem
                        </vs-th>
                        <vs-th class="text-base" sort-key="name">
                            Nome
                        </vs-th>
                        <vs-th class="text-base" style="width: 120px;" sort-key="discount_price">
                            Preço com Desconto
                        </vs-th>
                        <vs-th class="text-base" sort-key="price">
                            Preço
                        </vs-th>
                       <vs-th class="text-base" sort-key="amount" v-if="hasErpFeature">
                           Estoque
                       </vs-th>
                       <vs-th class="text-base" sort-key="amount">
                           Quantidade
                       </vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <tbody>
                            <vs-tr 
                                :data="tr" 
                                :key="tr.id"
                                :id="tr.id"
                                v-for="(tr, index) in dataOfProductsToPreOrder.product === undefined ? dataOfProductsToPreOrder : dataOfProductsToPreOrder.product"
                            > 
                                <vs-td :data="tr.image">
                                    <div class="d-flex flex-row items-center justify-around"> <!-- justify-evenly -->
                                      <img v-if="tr.image !== undefined && tr.image !== '' && tr.image != null" :src="tr.image" style="width: 50px !important; height: 50px !important;">
                                      <img v-else src="@/assets/images/products/product_without_photo.png" style="width: 40px !important; height: 40px !important;">
                                    </div>
                                </vs-td>

                                <vs-td :data="tr.name">
                                    <div class="d-flex flex-row items-center justify-around"> <!-- justify-evenly -->
                                        <p class="text-center">
                                            {{ tr.name }}
                                        </p>
                                    </div>
                                </vs-td>

                                <vs-td :data="tr.discount_price">
                                    <p class="text-center">
                                        <strong> 
                                            R$ {{ ((tr.discount_price ? tr.discount_price : tr.price) * quantityList[index]).toFixed(2).replace('.', ',') }}
                                            <feather-icon
                                            icon="EditIcon"
                                            class="edit-discount-price"
                                            @click="openDiscountModal(index, tr)"
                                            />
                                        </strong>
                                    </p>

                                </vs-td>

                                <vs-td :data="tr.price">
                                    <p class="text-center">
                                        <strong> 
                                            R$ {{ (tr.price * quantityList[index]).toFixed(2).replace('.', ',') }}
                                        </strong>
                                    </p>
                                </vs-td>

                                <vs-td :data="tr.amount" class="text-center amount-border" v-if="hasErpFeature">
<!--                                  Comentado, pois essa função deverá estar disponível apenas quando tem integração com ERP-->
                                    <p v-if="tr.integration_id !== null" class="text-center">
                                        Qtde. Estoque
                                        <strong>
                                            <span style="color: #1196e1; font-size: 16px;">{{ tr.amount }}</span>
                                        </strong>
                                    </p>
                                    <p v-else class="text-center">
                                        Estoque indisponível
                                    </p>
                                </vs-td>

                                <vs-td>
                                    <div>
                                        <div v-if="tr.integration_id !== null && tr.amount <= 0 && hasErpFeature">
                                            <vs-input-number v-if="enableNegativeStock" min="0" :step="1" v-model="quantityList[index]"/>
                                            <vs-chip v-else id="warn" color="warning">
                                                <feather-icon @mouseenter="alertQty()" feather-icon icon="SlashIcon"></feather-icon>
                                            </vs-chip >
                                        </div>
                                        <div v-else-if="tr.integration_id !== null && hasErpFeature && enableNegativeStock"> 
                                            <vs-input-number min="0" :step="1" v-model="quantityList[index]"/> 
                                        </div> 
                                        <div v-else-if="tr.integration_id !== null && hasErpFeature">
                                            <vs-input-number min="0" :max="tr.amount" :step="1" v-model="quantityList[index]"/>
                                        </div>
                                        <div v-else>
                                            <vs-input-number min="1" :step="1" v-model="quantityList[index]"/>
                                        </div>
                                    </div>
                                </vs-td>
                            </vs-tr>
                        </tbody>
                    </template>
                </vs-table>
            </div>
            <div>
                <vs-button @click="sendToNextFlow" class="btn-drop px-3 mr-5 mt-2 mb-2" type="filled" icon="keyboard_arrow_right" icon-after style="float: right !important; border-radius: 12px;">
                    {{ this.isCreateContext ? 'Próximo' : 'Atualizar'}}
                </vs-button>
            </div>
        </vs-popup>
    </div>
</template>

<script>
    import orderProduct from "@/http/requests/orderProduct";
    import { hasFeature } from "@/utils";

    export default {
        name: 'QuantityPopUp',
        data() {
            return {
                hasErpFeature: false,
            }
        },
        async mounted () {
            this.hasErpFeature = await hasFeature('erps')
        },
        computed: {
            enableNegativeStock() {
                return !!Number(this.$store.state.settings.settings.enable_negative_stock);
            },
        },
        methods: {
            closePopUp() {
                this.quantityList = [];
                
                this.isActive = false;
                this.$emit('isActiveFalse');
            },
            async sendToNextFlow() {
                let newDataOfProductsToPreOrder = {};
                if (this.dataOfProductsToPreOrder.product !== undefined) {
                    newDataOfProductsToPreOrder.product = this.dataOfProductsToPreOrder.product;
                } else {
                    newDataOfProductsToPreOrder.product = this.dataOfProductsToPreOrder;
                }

                await newDataOfProductsToPreOrder.product.forEach((item, index) => {
                    item.quantity = this.quantityList[index];
                    if (item.discount_price === undefined) {
                        item.discount_price = item.price;
                    }
                })

                if (this.updatePreOrder) {
                    this.$emit('updatePreOrderProducts', newDataOfProductsToPreOrder.product);
                    return;
                }

                const dataToUpdatePreOrder = [];
                if (!this.isCreateContext) {
                    newDataOfProductsToPreOrder.product.forEach((item) => {
                        dataToUpdatePreOrder.push({
                            id: item.id,
                            quantity: item.quantity,
                            discount_price: parseFloat(item.discount_price.toString().replace('.', ','))
                        })
                    })
                    
                    orderProduct.updateOrderProduct(this.dataToUpdate.data.id, dataToUpdatePreOrder)
                    .then((response) => {
                        this.$emit('updateProducts', 'quantity');
                        return this.$vs.notify({
                            color: 'success',
                            title: 'Sucesso!',
                            text: 'Atualização feita com sucesso!'
                        });
                    })
                    .catch((exception) => {
                        console.log(exception);
                        return this.$vs.notify({
                            color: 'danger',
                            title: 'Erro!',
                            text: 'Erro ao atualizar os dados, por favor nos contate para corrigir-mos!'
                        });
                    });
                } else {
                    newDataOfProductsToPreOrder.userId = this.dataOfProductsToPreOrder.userId;
                    this.$emit('sendDeliveryFlow', newDataOfProductsToPreOrder);
                }
            },
            alertQty() {
                let color = `#fc9e46`
                this.$vs.notify({title:'Aviso!',text:'Devido à falta de estoque, este produto não está disponível para venda no momento.',color:color,position:'bottom-left'})
            },
            openDiscountModal(index, value) {
                if (value.percentage_discount === 0) {
                    return this.$vs.notify({
                        title:'Aviso!',
                        text:'Este produto não pode receber desconto adicional',
                        color: 'warning'
                    });                    
                }

                let data = {
                    index: index,
                    product: value
                }
                this.$emit('setDiscountPrice', data)
            },
            changeDiscountPrice() {
                if (!this.dataOfProductsToPreOrder[this.newDiscountPrice.index]) {
                    this.dataOfProductsToPreOrder.product[this.newDiscountPrice.index].discount_price = this.newDiscountPrice.value
                } else {
                    this.dataOfProductsToPreOrder[this.newDiscountPrice.index].discount_price = this.newDiscountPrice.value
                }
                
                this.selectedRowIndex = null;
            }
        },
        watch: {
            isActive(val) {
                if (val) {
                    this.$vs.loading.close('#app > .con-vs-loading');
                }
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            dataOfProductsToPreOrder: {
                type: Array|Object,
                required: true
            },
            quantityList: {
                type: Array,
                required: true  
            },
            isCreateContext: {
                type: Boolean,
                required: true
            },
            updatePreOrder: {
                type: Boolean,
                required: true
            },
            dataToUpdate: {
                type: Array|Object,
                required: true
            },
        },
        emits: [
            'isActiveFalse',
            'backToProducts',
            'sendDeliveryFlow',
            'updateProducts',
            'setDiscountPrice'
        ]
    }
</script>

<style lang="scss">
    #popUpQuantityChat div.vs-popup {
        .vs-popup--content {
            padding: 15px;
            margin: 0;
        }
        margin: 0;
        border-radius: 18px !important;
        border: solid 1.2px;
        border-color: rgba(18, 17, 17, 0.769);
        width: 800px !important;
        .vs-popup--header {
            background-color: transparent !important;
            .vs-popup--title {
                background-color: transparent !important;
                h3 {
                    background-color: transparent !important;
                }
            }
        }
        header {
            background-color: transparent !important;

        }
        .d-flex.flex-row.items-center {
            display: flex;
            justify-content: space-evenly;
        }
        .vs-input-number.vs-input-number-size-null.vs-input-number-primary {
            background-color: #e3e2e236 !important;
            width: 110px;
        }
        td.td.vs-table--td:last-of-type {
            width: 150px;
        }
    }
    #warn {
        transform: translateX(4.8em);
        border-radius: 50%;
        width: 2em;
    }
    #tableDataOfQuantityChat {
        .vs-con-tbody.vs-table--tbody {
            background-color: transparent !important;
            border: 0 !important; 
        }
        table.vs-table.vs-table--tbody-table {
            border-collapse: separate;
            border-spacing: 0 0.5rem;
            padding: 0 1rem;

        }
        header {
            //float: left;
            align-items: center;
            margin-left: 16px;
            margin-right: 16px;
            div > input {
                border: solid 0.1px !important;
                color: #726f6fb4;
            }
        }
        tbody {  
            tr.tr-values.vs-table--tr.tr-table-state-null.is-selected.selected {
                border-radius: 14px !important;
            }
            td {
                padding: 0px;
                border-style: solid; 
                border-color: #b6bebd6e;
                margin-top: 4px;
                margin-bottom: 1px;
            }
            td:first-of-type {
                border-top-left-radius: 14px; 
                border-bottom-left-radius: 14px; 
                border-width: 1px 0px 1px 1px; 
                
            }
            td:last-of-type {
                border-top-right-radius: 14px; 
                border-bottom-right-radius: 14px; 
                border-width: 1px 1px 1px 0px; 
            }
            td:nth-of-type(2), td:nth-of-type(3), td:nth-of-type(4) {
                border-width: 1px 0px 1px 0px; 
            }
        }
    }
    .amount-border {
        border-top: 1px solid #b6bebd6e;
        border-bottom: 1px solid #b6bebd6e;
    }
    .edit-discount-price {
        cursor: pointer;
        top: 2.5px;
        transition: .1s;
        svg{
            
            width: 1.12rem !important;
            height: 1.12rem !important;
        }
    }
    .edit-discount-price:hover {
        transition: .1s;
        color:#409eff;
    }
    .change-discount-price{
        margin-left: 1rem;
        box-shadow: 2px 0px 14px rgba(0, 0, 0, 0.2);
        border: 1px solid #409eff;
        border-radius: 7px;
        span{
            width:100px;
        }
        .vs-con-input-label .vs-con-input .vs-input--input{
            border:none !important;
            padding: 0.9rem !important;
            padding-right: 0 !important;
            font-weight: 600;
        }
        .vs-con-input-label .vs-con-input .vs-input--input:focus{
            border: none !important;
            box-shadow: none !important;

        }
    }
    .confirm-discount-price{
        padding-left: 6px;
        width: 32px !important;
        transition: .1s;
        cursor: pointer;
        svg{
            width: 1.15rem !important;
            height: 1.15rem !important;
        }
    }
    .confirm-discount-price:hover {
        transition: .1s;
        color:#409eff;
    }
</style>
